import { Modal } from 'src/components/Modal';
import styled, { css } from 'styled-components';

export const ModalWrapper = styled(Modal)(
  ({ theme }) => css`
    .reactModalContent {
      max-width: ${theme.sz.xl};
      padding-top: ${theme.sz.s10};
      min-height: min(${theme.sz.ms}, 90dvh);
    }
  `,
);
